module.exports = __webpack_public_path__ + "img/banner_jupiler2.c5873bdc.png";